module.exports = __webpack_public_path__ + "img/logo-light.25d16a54.png";